import { render, staticRenderFns } from "./StaffUsers.vue?vue&type=template&id=169af08c&scoped=true"
import script from "./StaffUsers.vue?vue&type=script&lang=js"
export * from "./StaffUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169af08c",
  null
  
)

export default component.exports